import AppContext from "PFApp/app_context";
import { useContext } from "react";

import { ShareModal } from "../../../components/activity_share/share_modal";
import { BulkAddCoOwnerModal } from "../bulk_select_overlay/bulk_add_co_owner_modal/bulk_add_co_owner_modal";

export const Modals = () => {
  const {
    store: {
      pages: {
        workflowPage: { tab, roles, engagements }
      }
    }
  } = useContext(AppContext);

  const {
    selectedIds,
    setSelectedIds,
    data: { entries: items },
    modals: { share: shareModal, addCoOwner: addCoOwnerModal }
  } = tab === "roles" ? roles : engagements;

  const handleCloseShare = () => {
    shareModal?.setVisibility(false);
  };

  const handleCloseAddCoOwner = () => {
    addCoOwnerModal.setVisibility(false);
  };

  const handleSuccess = () => {
    setSelectedIds([]);
    handleCloseShare();
    handleCloseAddCoOwner();
  };

  return (
    <>
      {shareModal?.isVisible && (
        <ShareModal
          activityIds={selectedIds}
          activityType={tab === "roles" ? "role" : "engagement"}
          onSuccess={handleSuccess}
          onClose={handleCloseShare}
        />
      )}
      {addCoOwnerModal.isVisible && (
        <BulkAddCoOwnerModal
          allItems={items}
          selectedIds={selectedIds}
          onSuccess={handleSuccess}
          onClose={handleCloseAddCoOwner}
        />
      )}
    </>
  );
};
